var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilledFolder = function SvgFilledFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 18v-4.375a4 4 0 0 0-4-4h-1.896a4 4 0 0 1-2.357-.768l-1.494-1.089A4 4 0 0 0 8.897 7H7a4 4 0 0 0-4 4v7a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#28303F",
    d: "M17 9.625h-1.896a4 4 0 0 1-2.357-.768l-1.494-1.089A4 4 0 0 0 8.897 7H7c-.729 0-1.412.195-2 .535V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6.16a4 4 0 0 0-2-.535"
  })));
};
export default SvgFilledFolder;